
import { defineComponent, ref } from 'vue'
import QForm from 'quasar/src/components/form/QForm.js';
import { useRoute } from 'vue-router'
import { useAgreementModule } from '@/modules/agreements'
import { useFormModule } from '@/modules/_shared/forms'

export default defineComponent({
    name: 'agreement-form-field-editable-in-self-service',
    props: {
        modelValue: {
            type: Boolean,
            required: true
        },
        disable: {
            type: Boolean,
            required: false
        }
    },
    setup (props, { emit }) {
        const route = useRoute()
        const { submitForm, createOnSuccess } = useFormModule()
        const { enableEditInSelfService, disableEditInSelfService } = useAgreementModule()
        const localValue = ref(props.modelValue)
        const form = ref<QForm>()

        const sendEnableEditRequest = async () => enableEditInSelfService(route.params.agreementId as string)
        const sendDisableEditRequest = async () => disableEditInSelfService(route.params.agreementId as string)

        const onSubmit = () => localValue.value ? onEnableEdit() : onDisableEdit()

        const onEnableEdit = () => submitForm(
            form.value,
            sendEnableEditRequest,
            () => {
                emit('update:modelValue', localValue.value)
                createOnSuccess('Edit in Self-service allowed')()
            }
        )

        const onDisableEdit = () => submitForm(
            form.value,
            sendDisableEditRequest,
            () => {
                emit('update:modelValue', localValue.value)
                createOnSuccess('Edit in Self-service denied')()
            }
        )

        return {
            localValue,
            onSubmit,
            form
        }
    }
})
